module.exports = __webpack_public_path__ + "static/media/pates.bb12dc10.svg";